// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Meant for home page #services */
.services-section-ct h3 {
  text-align: center;
  text-transform: uppercase;
}

.question-answer-ct {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px 10px;
  margin-bottom: 30px;
}

.question-answer-ct blockquote {
  max-width: 270px;
  padding: 30px 20px;
  margin: 0;
  font-family: var(--font-family1);
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
}


/* QUESTION */
.question-answer-ct .question {
  position: relative;
  color: #fff;
  background: #075698;
  background: -webkit-gradient(linear, 0 0, 0 100%, from(var(--brand-blue2)), to(var(--brand-blue1)));
  background: -moz-linear-gradient(var(--brand-blue2), var(--btn-blue1));
  background: -o-linear-gradient(var(--brand-blue2), var(--btn-blue1));
  background: linear-gradient(var(--brand-blue2), var(--btn-blue1));
  -webkit-border-top-left-radius: 220px 120px;
  -webkit-border-top-right-radius: 220px 120px;
  -webkit-border-bottom-right-radius: 220px 120px;
  -webkit-border-bottom-left-radius: 220px 120px;
  -moz-border-radius: 220px / 120px;
  border-radius: 220px / 120px;
}
.question-answer-ct .question::before {
  content: "";
  position: absolute;
  bottom: -2rem;
  left: 50px;
  width: 30px;
  height: 30px;
  background: var(--brand-blue2);
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
}
.question-answer-ct .question::after {
  content: "";
  position: absolute;
  bottom: -30px;
  left: 30px;
  width: 15px;
  height: 15px;
  background: var(--brand-blue2);
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
}



/* ANSWER */
.question-answer-ct .answer {
  position: relative;
  color: #fff;
  background: #c81e2b;
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f04349), to(#c81e2b));
  background: -moz-linear-gradient(#f04349, #c81e2b);
  background: -o-linear-gradient(#f04349, #c81e2b);
  background: linear-gradient(#f04349, #c81e2b);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.question-answer-ct .answer::before {
  content: "";
  position: absolute;
  bottom: -40px;
  right: 60px;
  border: 0;
  border-right-width: 30px;
  border-bottom-width: 40px;
  border-style: solid;
  border-color: transparent #c81e2b;
  display: block;
  width: 0;
}
/* .question-answer-ct .answer::after {

} */



/* SHORT DESCRIPTION */
.short-description-wrapper {
  padding: 5px;
}

.services-section-ct .short-description-ct {
  display: flex;
  justify-content: center;
}

.services-section-ct .short-description-ct p {
  margin: 0;
  padding: 10px;
  border: 5px solid #c81e2b;
  border-radius: 30px;
  width: 100%;
  max-width: 650px;
  text-align: center;
}



/* LISTS */
.services-list-ct {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
}

.services-list-ct h4 {
  text-align: center;
  font-family: var(--font-family1);
}

.services-list-ct ul {
  margin: 0;
}

.services-list-ct li {
  width: 250px;
}
.services-list-ct li::marker {
  color: var(--brand-red1);
  font-size: 1.8rem;
}



/* FREE SUPPORT */
.free-support-sections-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.free-support-sections-ct {
  border-radius: 20px;
  padding: 0 10px 0 1rem;
}

.free-support-sections-ct > div {
  width: 100%;
  max-width: 1200px;
}

.free-support-sections-ct p {
  text-indent: 1.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/services.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mGAAmG;EACnG,sEAAsE;EACtE,oEAAoE;EACpE,iEAAiE;EACjE,2CAA2C;EAC3C,4CAA4C;EAC5C,+CAA+C;EAC/C,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;;;;AAIA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,6EAA6E;EAC7E,kDAAkD;EAClD,gDAAgD;EAChD,6CAA6C;EAC7C,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,QAAQ;AACV;AACA;;GAEG;;;;AAIH,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;;;AAIA,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;;;AAIA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Meant for home page #services */\n.services-section-ct h3 {\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.question-answer-ct {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 40px 10px;\n  margin-bottom: 30px;\n}\n\n.question-answer-ct blockquote {\n  max-width: 270px;\n  padding: 30px 20px;\n  margin: 0;\n  font-family: var(--font-family1);\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n\n/* QUESTION */\n.question-answer-ct .question {\n  position: relative;\n  color: #fff;\n  background: #075698;\n  background: -webkit-gradient(linear, 0 0, 0 100%, from(var(--brand-blue2)), to(var(--brand-blue1)));\n  background: -moz-linear-gradient(var(--brand-blue2), var(--btn-blue1));\n  background: -o-linear-gradient(var(--brand-blue2), var(--btn-blue1));\n  background: linear-gradient(var(--brand-blue2), var(--btn-blue1));\n  -webkit-border-top-left-radius: 220px 120px;\n  -webkit-border-top-right-radius: 220px 120px;\n  -webkit-border-bottom-right-radius: 220px 120px;\n  -webkit-border-bottom-left-radius: 220px 120px;\n  -moz-border-radius: 220px / 120px;\n  border-radius: 220px / 120px;\n}\n.question-answer-ct .question::before {\n  content: \"\";\n  position: absolute;\n  bottom: -2rem;\n  left: 50px;\n  width: 30px;\n  height: 30px;\n  background: var(--brand-blue2);\n  -webkit-border-radius: 30px;\n  -moz-border-radius: 30px;\n  border-radius: 30px;\n}\n.question-answer-ct .question::after {\n  content: \"\";\n  position: absolute;\n  bottom: -30px;\n  left: 30px;\n  width: 15px;\n  height: 15px;\n  background: var(--brand-blue2);\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  border-radius: 15px;\n}\n\n\n\n/* ANSWER */\n.question-answer-ct .answer {\n  position: relative;\n  color: #fff;\n  background: #c81e2b;\n  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f04349), to(#c81e2b));\n  background: -moz-linear-gradient(#f04349, #c81e2b);\n  background: -o-linear-gradient(#f04349, #c81e2b);\n  background: linear-gradient(#f04349, #c81e2b);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n}\n.question-answer-ct .answer::before {\n  content: \"\";\n  position: absolute;\n  bottom: -40px;\n  right: 60px;\n  border: 0;\n  border-right-width: 30px;\n  border-bottom-width: 40px;\n  border-style: solid;\n  border-color: transparent #c81e2b;\n  display: block;\n  width: 0;\n}\n/* .question-answer-ct .answer::after {\n\n} */\n\n\n\n/* SHORT DESCRIPTION */\n.short-description-wrapper {\n  padding: 5px;\n}\n\n.services-section-ct .short-description-ct {\n  display: flex;\n  justify-content: center;\n}\n\n.services-section-ct .short-description-ct p {\n  margin: 0;\n  padding: 10px;\n  border: 5px solid #c81e2b;\n  border-radius: 30px;\n  width: 100%;\n  max-width: 650px;\n  text-align: center;\n}\n\n\n\n/* LISTS */\n.services-list-ct {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n  padding: 10px 0;\n}\n\n.services-list-ct h4 {\n  text-align: center;\n  font-family: var(--font-family1);\n}\n\n.services-list-ct ul {\n  margin: 0;\n}\n\n.services-list-ct li {\n  width: 250px;\n}\n.services-list-ct li::marker {\n  color: var(--brand-red1);\n  font-size: 1.8rem;\n}\n\n\n\n/* FREE SUPPORT */\n.free-support-sections-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.free-support-sections-ct {\n  border-radius: 20px;\n  padding: 0 10px 0 1rem;\n}\n\n.free-support-sections-ct > div {\n  width: 100%;\n  max-width: 1200px;\n}\n\n.free-support-sections-ct p {\n  text-indent: 1.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
